import z from 'zod'

export const ticketSchema = z.object({
	requesttype: z.string().min(1, 'Request type is required'),
	summary: z.string().max(256),
	message: z.string().max(256),
	attachments: z.array(z.instanceof(File)).optional(),
})
